var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                        icon: "el-icon-refresh",
                      },
                      on: { click: _vm.syncDepartment },
                    },
                    [_vm._v("同步部门")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                        icon: "el-icon-refresh",
                      },
                      on: { click: _vm.syncDepartmentUser },
                    },
                    [_vm._v("同步员工")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c(
            "el-aside",
            { attrs: { width: "200px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "text" },
                  on: { click: _vm.getDeptStaffTree },
                },
                [_vm._v("刷新部门")]
              ),
              _vm._v(" "),
              _c("el-tree", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.deptStaffTreeLoading,
                    expression: "deptStaffTreeLoading",
                  },
                ],
                attrs: {
                  data: _vm.deptStaffTree,
                  props: _vm.defaultProps,
                  "node-key": "id",
                  "default-expand-all": "",
                },
                on: { "node-click": _vm.handleNodeClick },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-main",
            [
              _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                staticStyle: { width: "400px" },
                                attrs: {
                                  size: "small",
                                  placeholder: "输入关键字(部门，名称)进行过滤",
                                  clearable: "",
                                },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.getDeptStaffUserPage($event)
                                  },
                                },
                                model: {
                                  value: _vm.listQuery.keywords,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.listQuery, "keywords", $$v)
                                  },
                                  expression: "listQuery.keywords",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "small",
                                    type: "primary",
                                    icon: "el-icon-search",
                                  },
                                  on: { click: _vm.getDeptStaffUserPage },
                                },
                                [_vm._v("搜索")]
                              ),
                              _vm._v(" "),
                              _vm.total > 0
                                ? _c("sw-page", {
                                    attrs: {
                                      "list-query": _vm.listQuery,
                                      total: _vm.total,
                                      pos: "btmRight",
                                    },
                                    on: { retPage: _vm.getDeptStaffUserPage },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c(
                    "el-table",
                    { attrs: { data: _vm.userList, stripe: "", border: "" } },
                    [
                      _c("el-table-column", {
                        attrs: { label: "工号", prop: "staffNo", width: "300" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "名称",
                          prop: "staffName",
                          width: "150",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "职位",
                          prop: "position",
                          width: "100",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "所属部门",
                          prop: "deptPathName",
                          width: "350",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _vm._l(row.deptNames, function (deptName, idx) {
                                  return [
                                    _c("el-tag", { attrs: { size: "mini" } }, [
                                      _vm._v(_vm._s(deptName)),
                                    ]),
                                    _vm._v(" "),
                                    idx < row.deptNames.length - 1
                                      ? _c("span", {
                                          staticClass: "el-icon-right",
                                        })
                                      : _vm._e(),
                                  ]
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "手机号码",
                          prop: "mobileNo",
                          width: "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "邮箱",
                          prop: "staffEmail",
                          width: "200",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "状态",
                          prop: "statusDisplayName",
                          width: "100",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }